// components
import GridPageAbstract from '../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../utils/gridHeadStorage';
import { COMMISSION_KIND } from '../../constants/commissionKind';
import { COMMISSION_CALCULATION } from '../../constants/commissionCalculation';
import { COMMISSION_DIMENSION } from '../../constants/commissionDimension';

export default class CommissionsPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'publicCommissions';
        this.Server = this.props.context.getState().server.publicCommissions;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['name'];

        const defaultHead = [
            { id: 'name', required: true, group: 'definition', label: 'name', alignRight: false, cell: 'Text', displayGrid: true },
            {
                id: 'kind', required: true, group: 'definition',
                label: 'kind',
                alignRight: false,
                cell: 'Items',
                items: COMMISSION_KIND,
                displayGrid: true
            },
            {
                id: 'calculation', group: 'definition',
                label: 'calculationType',
                alignRight: false,
                cell: 'Items',
                items: COMMISSION_CALCULATION,
                displayGrid: true
            },
            {
                id: 'dimension', group: 'definition',
                label: 'dimension',
                alignRight: false,
                cell: 'Items',
                items: COMMISSION_DIMENSION,
                displayGrid: true
            },
            { id: 'fee', group: 'amounts', label: 'fee', alignRight: true, cell: 'Number', displayGrid: true },
            { id: 'minimalCommission', group: 'amounts', label: 'minimalCommission', alignRight: true, cell: 'Amount', displayGrid: true },
            {
                id: 'merchantTerminalId', group: 'appliesTo',
                label: 'merchantTerminal',
                alignRight: false,
                cell: 'Select',
                from: 'publicMerchantTerminals',
                object: 'merchantTerminal',
                show: 'name',
                displayGrid: true
            },
            {
                id: 'gatewayId', group: 'appliesTo',
                label: 'gateway',
                alignRight: false,
                cell: 'Select',
                from: 'publicGateways',
                object: 'gateway',
                show: 'name',
                displayGrid: true
            },
            {
                id: 'agentId', group: 'appliesTo',
                label: 'agent',
                alignRight: false,
                cell: 'Select',
                from: 'publicAgents',
                object: 'agent',
                show: 'name',
                displayGrid: true
            },
            { id: 'dateFrom', group: 'validity', label: 'dateFrom', alignRight: false, cell: 'DateTime', displayGrid: true },
            { id: 'dateTo', group: 'validity', label: 'dateTo', alignRight: false, cell: 'DateTime', displayGrid: true },
            { id: 'comment', group: 'notes', label: 'comment', alignRight: false, cell: 'BigText', displayGrid: true },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'modifiedBy',
                label: 'modifiedBy',
                alignRight: false,
                cell: 'Select',
                object: 'modifiedBy',
                show: 'firstName+lastName',
                displayGrid: true,
                disableEditor: true,
                customSort: 'modifiedBy.firstName'
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
